// i18nOwl-ignore [app-youtube.medias.video.title]
import MediaContentYoutubeVideo from '@cohort/components-xps/components/contents/apps/youtube/video/MediaContentYoutubeVideo';
import type {ContentMedia} from '@cohort/merchants/apps';
import YoutubeVideoMediaConfigComponent from '@cohort/merchants/apps/youtube/medias/video/ConfigComponent';
import YoutubeVideoVisualPreview from '@cohort/merchants/apps/youtube/medias/video/VisualPreview';
import type {YoutubeVideoMediaStruct} from '@cohort/shared/apps/youtube/medias/video';
import {YoutubeVideoMediaSpec} from '@cohort/shared/apps/youtube/medias/video';
import {SvgAppIcon} from '@cohort/shared-frontend/common/AppIcons';

export const YoutubeVideoMedia: ContentMedia<YoutubeVideoMediaStruct> = {
  spec: YoutubeVideoMediaSpec,
  configComponent: YoutubeVideoMediaConfigComponent,
  getTitle: t => t('medias.video.title', {ns: 'app-youtube'}),
  mediaContent: MediaContentYoutubeVideo,
  icon: ({size}) => <SvgAppIcon name="youtube" height={size} width={size} />,
  visualPreview: YoutubeVideoVisualPreview,
};
